import {
  WaitingOfferDialogComponent,
  WaitingOfferDialogData
} from './waiting-offer-dialog/waiting-offer-dialog.component';
import {
  LoadingOffersDialogComponent,
  LoadingOffersDialogData
} from './loading-offer-dialog/loading-offers-dialog.component';
import { InformationDialogComponent, InformationDialogData } from './information-dialog/information-dialog.component';
import {
  OfferRecalculationDialogComponent,
  OfferRecalculationDialogData
} from './offer-recalculation-dialog/offer-recalculation-dialog.component';
import { ConfigurationService } from '../../../core/services/impl/configuration/configuration.service';
import { MatDialogRef } from '@angular/material';
import {isNext, isMPay, isSkycash, isYANOSIK, isNestBank} from '../../../core/utils/utils';
import {DriverSosDetailsDialogComponent} from './driver-sos-details-dialog/driver-sos-details-dialog.component';
import {PdfViewerDialogComponent} from './pdf-viewer-dialog/pdf-viewer-dialog.component';
import {AztecScannerQrDialogComponent} from './aztec-scanner-qr-dialog/aztec-scanner-qr-dialog.component';
import {ImagePreviewDialogComponent} from './image-preview-dialog/image-preview-dialog.component';
import {OffersProgressDialogComponent} from './offers-progress-dialog/offers-progress-dialog.component';
import {AssetsService} from '../../services/assets.service';

export class DialogsConfiguration {

  isNext = isNext();

  private _config: DialogsConfig = {
    [DialogKey.WAITING_FOR_OFFERS]: {
      key: DialogKey.WAITING_FOR_OFFERS,
      component: WaitingOfferDialogComponent,
      dialogData: this.waitingOfferDialogConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.LOADING_OFFERS]: {
      key: DialogKey.LOADING_OFFERS,
      component: LoadingOffersDialogComponent,
      dialogData: this.loadingOffersDialogConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.OFFERS_PROGRESS]: {
      key: DialogKey.OFFERS_PROGRESS,
      component: OffersProgressDialogComponent,
      dialogData: {
        canCloseOnNavigation: true
      },
      dialog: null,
      isOpened: false
    },
    [DialogKey.UNSUPPORTED_DATA]: {
      key: DialogKey.UNSUPPORTED_DATA,
      component: InformationDialogComponent,
      dialogData: this.unsupportedDataDialogConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.NO_OFFERS_FOUND]: {
      key: DialogKey.NO_OFFERS_FOUND,
      component: InformationDialogComponent,
      dialogData: this.noOffersFoundDialogConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.NOT_UNIQUE_PESEL_NUMBERS]: {
      key: DialogKey.NOT_UNIQUE_PESEL_NUMBERS,
      component: InformationDialogComponent,
      dialogData: this.notUniquePeselNumbersConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.ENTRY_INFORMATION]: {
      key: DialogKey.ENTRY_INFORMATION,
      component: InformationDialogComponent,
      dialogData: this.entryInformationConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.OFFER_UPDATE]: {
      key: DialogKey.OFFER_UPDATE,
      component: InformationDialogComponent,
      dialogData: this.offerUpdateConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.UNEDITABLE_SESSION]: {
      key: DialogKey.UNEDITABLE_SESSION,
      component: InformationDialogComponent,
      dialogData: this.uneditableSessionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.CALCULATION_ERROR]: {
      key: DialogKey.CALCULATION_ERROR,
      component: InformationDialogComponent,
      dialogData: this.calculationErrorConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.OFFER_RECALCULATION]: {
      key: DialogKey.OFFER_RECALCULATION,
      component: OfferRecalculationDialogComponent,
      dialogData: this.offerRecalculationConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.MISSING_ANTITHEFT_DEVICE_EXCEPTION]: {
      key: DialogKey.MISSING_ANTITHEFT_DEVICE_EXCEPTION,
      component: InformationDialogComponent,
      dialogData: this.missingAntitheftDeviceExceptionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.USA_CANADA_IMPORTED_WITH_AC_EXCEPTION]: {
      key: DialogKey.USA_CANADA_IMPORTED_WITH_AC_EXCEPTION,
      component: InformationDialogComponent,
      dialogData: this.usaCanadaImportedWithAcExceptionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION]: {
      key: DialogKey.TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION,
      component: InformationDialogComponent,
      dialogData: this.tooDistantStartInsuranceDateExceptionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.MISSING_PERSONAL_DATA]: {
      key: DialogKey.MISSING_PERSONAL_DATA,
      component: InformationDialogComponent,
      dialogData: this.missingPersonalDataExceptionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.MISSING_REGISTRATION_NUMBER]: {
      key: DialogKey.MISSING_REGISTRATION_NUMBER,
      component: InformationDialogComponent,
      dialogData: this.missingRegistrationNUmberExceptionConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.INCORRECT_DISCOUNT_CODE]: {
      key: DialogKey.INCORRECT_DISCOUNT_CODE,
      component: InformationDialogComponent,
      dialogData: this.incorrectDiscountCodeConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.DRIVER_SOS_DETAILS]: {
      key: DialogKey.DRIVER_SOS_DETAILS,
      component: DriverSosDetailsDialogComponent,
      dialogData: {
        actionKey: DialogAction.BACK_TO_FIRST_STEP
      },
      dialog: null,
      isOpened: false
    },
    [DialogKey.PDF_VIEWER]: {
      key: DialogKey.PDF_VIEWER,
      component: PdfViewerDialogComponent,
      dialog: null,
      isOpened: false
    },
    [DialogKey.CLIENT_BLACK_LISTED]: {
      key: DialogKey.INCORRECT_DISCOUNT_CODE,
      component: InformationDialogComponent,
      dialogData: this.clientBlackListedConfig,
      dialog: null,
      isOpened: false
    },
    [DialogKey.AZTEC_SCANNER_QR_DIALOG]: {
      key: DialogKey.AZTEC_SCANNER_QR_DIALOG,
      component: AztecScannerQrDialogComponent,
      dialog: null,
      isOpened: false,
    },
    [DialogKey.IMAGE_PREVIEW_DIALOG]: {
      key: DialogKey.IMAGE_PREVIEW_DIALOG,
      component: ImagePreviewDialogComponent,
      dialog: null,
      isOpened: false,
    }
  };

  constructor(private configuration: ConfigurationService,
              private assetsService: AssetsService) {}

  get config() {
    return this._config;
  }

  get waitingOfferDialogConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.waitingOfferDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.waitingOfferDialogConfig;
    }
    return {
      header: 'WAITING_OFFER_DIALOG_COMPONENT.header',
      offersMessage: 'WAITING_OFFER_DIALOG_COMPONENT.offersMessage',
      analysisMessage: 'WAITING_OFFER_DIALOG_COMPONENT.analysisMessage',
      footer: 'WAITING_OFFER_DIALOG_COMPONENT.footer',
      ...configFromConfiguration
    }
  }

  get loadingOffersDialogConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.loadingOfferDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.loadingOfferDialogConfig;
    }
    const analysisMessage = isYANOSIK() ? 'LOADING_OFFERS_DIALOG_COMPONENT.unspecifiedTimeMessage' : 'LOADING_OFFERS_DIALOG_COMPONENT.maxTimeMessage';
    return {
      ...configFromConfiguration,
      header: 'LOADING_OFFERS_DIALOG_COMPONENT.header',
      offersMessage: 'LOADING_OFFERS_DIALOG_COMPONENT.offersMessage',
      analysisMessage: analysisMessage,
      actionText: 'LOADING_OFFERS_DIALOG_COMPONENT.actionText',
      actionKey: DialogAction.ENABLE_SCROLLING,
      canCloseOnNavigation: false
    }
  }

  get unsupportedDataDialogConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.unsupportedDataDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.unsupportedDataDialogConfig;
    }
    return {
      header: 'UNSUPPORTED_DATA_DIALOG_COMPONENT.header',
      mainText: 'UNSUPPORTED_DATA_DIALOG_COMPONENT.mainText',
      additionalText: 'UNSUPPORTED_DATA_DIALOG_COMPONENT.additionalText',
      footer: 'UNSUPPORTED_DATA_DIALOG_COMPONENT.footer',
      actionText: 'UNSUPPORTED_DATA_DIALOG_COMPONENT.actionText',
      ...configFromConfiguration,
      imageSrc: isNestBank() ? 'assets/images/nest-bank-keys.png' : 'assets/images/unsupported-data.svg',
      dialogClass: 'unsupported-data-dialog',
      panelClass: 'unsupported-data-dialog-panel'
    }
  }

  get noOffersFoundDialogConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.noOffersFoundDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.noOffersFoundDialogConfig;
    }

    return {
      header: 'NO_OFFERS_FOUND_DIALOG_COMPONENT.header',
      mainText: 'NO_OFFERS_FOUND_DIALOG_COMPONENT.mainText',
      actionText: 'NO_OFFERS_FOUND_DIALOG_COMPONENT.actionText',
      ...configFromConfiguration
    };
  }

  get notUniquePeselNumbersConfig(): any {
    return {
      imageSrc: this.assetsService.informationDialogImageSrc,
      header: 'NOT_UNIQUE_PESEL_NUMBERS_DIALOG_COMPONENT.header',
      mainText: 'NOT_UNIQUE_PESEL_NUMBERS_DIALOG_COMPONENT.mainText',
      actionText: 'NOT_UNIQUE_PESEL_NUMBERS_DIALOG_COMPONENT.actionText'
    };
  }

  get entryInformationConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.entryInformationDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.entryInformationDialogConfig;
    }
    return {
      header: 'ENTRY_INFORMATION_DIALOG_COMPONENT.header',
      mainText: 'ENTRY_INFORMATION_DIALOG_COMPONENT.mainText',
      actionText: 'ENTRY_INFORMATION_DIALOG_COMPONENT.actionText',
      additionalText: 'ENTRY_INFORMATION_DIALOG_COMPONENT.additionalText',
      ...configFromConfiguration,
      dialogClass: 'entry-information-dialog'
    };
  }

  get offerUpdateConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.offerUpdateDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.offerUpdateDialogConfig;
    }
    return {
      header: 'OFFER_UPDATE_DIALOG_COMPONENT.header',
      mainText: 'OFFER_UPDATE_DIALOG_COMPONENT.mainText',
      actionText: 'OFFER_UPDATE_DIALOG_COMPONENT.actionText',
      actionKey: DialogAction.SHOW_SECOND_STEP,
      additionalText: 'OFFER_UPDATE_DIALOG_COMPONENT.additionalText',
      ...configFromConfiguration,
      imageAboveHeader: true,
      canCloseOnNavigation: false
    };
  }

  get uneditableSessionConfig(): any {
    return {
      imageSrc: this.assetsService.informationDialogImageSrc,
      header: 'UNEDITABLE_SESSION_DIALOG_COMPONENT.header',
      canCloseOnNavigation: false
    }
  }

  get calculationErrorConfig(): any {
    return {
      imageSrc: this.assetsService.informationDialogImageSrc,
      header: 'CALCULATION_ERROR_DIALOG_COMPONENT.header',
      actionText: 'CALCULATION_ERROR_DIALOG_COMPONENT.actionText',
    }
  }

  get offerRecalculationConfig(): any {
    let configFromConfiguration = {};
    if (this.configuration.uiConfig.offerRecalculationDialogConfig) {
      configFromConfiguration = this.configuration.uiConfig.offerRecalculationDialogConfig;
    }
    return {
      ...configFromConfiguration,
      imageSrc: this.assetsService.informationDialogImageSrc, // FIXME move imageSrc to configuration
      backToOffersActionKey: DialogAction.BACK_TO_OFFERS,
      payActionKey: DialogAction.PAY_AFTER_RECALCULATION
    }
  }

  get missingAntitheftDeviceExceptionConfig(): any {
    return {
      header: 'MISSING_ANTITHEFT_DEVICE_EXCEPTION_DIALOG_COMPONENT.header',
      mainText: 'MISSING_ANTITHEFT_DEVICE_EXCEPTION_DIALOG_COMPONENT.mainText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      actionText: 'MISSING_ANTITHEFT_DEVICE_EXCEPTION_DIALOG_COMPONENT.actionText',
    }
  }

  get usaCanadaImportedWithAcExceptionConfig(): any {
    return {
      header: 'USA_CANADA_IMPORTED_WITH_AC_EXCEPTION_DIALOG_COMPONENT.header',
      mainText: 'USA_CANADA_IMPORTED_WITH_AC_EXCEPTION_DIALOG_COMPONENT.mainText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      actionText: 'USA_CANADA_IMPORTED_WITH_AC_EXCEPTION_DIALOG_COMPONENT.actionText',
    }
  }

  get tooDistantStartInsuranceDateExceptionConfig(): any {
    return {
      header: 'TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION_DIALOG_COMPONENT.header',
      imageSrc: this.assetsService.informationDialogImageSrc,
      footer: 'TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION_DIALOG_COMPONENT.footer',
      actionText: 'TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION_DIALOG_COMPONENT.actionText',
      actionKey: DialogAction.BACK_TO_FIRST_STEP,
      dialogClass: 'short-paragraphs-dialog',
    }
  }

  get missingPersonalDataExceptionConfig(): any {
    return {
      header: 'MISSING_PERSONAL_DATA_DIALOG_COMPONENT.header',
      additionalText: 'MISSING_PERSONAL_DATA_DIALOG_COMPONENT.additionalText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      actionText: 'MISSING_PERSONAL_DATA_DIALOG_COMPONENT.actionText',
      actionKey: DialogAction.BACK_TO_PERSONAL_DATA,
    };
  }

  get missingRegistrationNUmberExceptionConfig(): any {
    return {
      header: 'MISSING_REGISTRATION_NUMBER_DIALOG_COMPONENT.header',
      mainText: 'MISSING_REGISTRATION_NUMBER_DIALOG_COMPONENT.mainText',
      additionalText: 'MISSING_REGISTRATION_NUMBER_DIALOG_COMPONENT.additionalText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      actionText: 'MISSING_REGISTRATION_NUMBER_DIALOG_COMPONENT.actionText',
      actionKey: DialogAction.BACK_TO_FIRST_STEP,
    };
  }

  get incorrectDiscountCodeConfig(): any {
    return {
      header: 'INCORRECT_DISCOUNT_CODE_DIALOG_COMPONENT.header',
      mainText: 'INCORRECT_DISCOUNT_CODE_DIALOG_COMPONENT.mainText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      actionText: 'INCORRECT_DISCOUNT_CODE_DIALOG_COMPONENT.actionText'
    };
  }

  get clientBlackListedConfig(): any {
    return {
      header: 'CLIENT_BLACK_LISTED_DIALOG_COMPONENT.header',
      mainText: 'CLIENT_BLACK_LISTED_DIALOG_COMPONENT.mainText',
      imageSrc: this.assetsService.informationDialogImageSrc,
      panelClass: 'client-black-listed-dialog',
      canCloseOnNavigation: false
    };
  }
}

export type DialogsConfig = { [key in DialogKey]: DialogConfig };

export interface DialogConfig {
  key: DialogKey;
  component: any;
  dialogData?: DialogComponentData;
  dialog: MatDialogRef<any>;
  isOpened: boolean;
  actions?: DialogActionConfig[];
}

export type DialogComponentData = WaitingOfferDialogData | InformationDialogData | LoadingOffersDialogData | OfferRecalculationDialogData | any;

export enum DialogKey {
  WAITING_FOR_OFFERS = 'waitingForOffers',
  LOADING_OFFERS = 'loadingOffers',
  OFFERS_PROGRESS = 'offersProgress',
  UNSUPPORTED_DATA = 'unsupportedData',
  NO_OFFERS_FOUND = 'noOffersFound',
  NOT_UNIQUE_PESEL_NUMBERS = 'notUniquePeselNumbers',
  ENTRY_INFORMATION = 'entryInformation',
  OFFER_UPDATE = 'offerUpdate',
  UNEDITABLE_SESSION = 'uneditableSession',
  CALCULATION_ERROR = 'calculationError',
  OFFER_RECALCULATION = 'offerRecalculation',
  MISSING_ANTITHEFT_DEVICE_EXCEPTION = 'missingAntitheftDeviceException',
  USA_CANADA_IMPORTED_WITH_AC_EXCEPTION = 'usaCanadaImportedWithAcException',
  TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION = 'tooDistantStartInsuranceDateException',
  MISSING_PERSONAL_DATA = 'missingPersonalData',
  MISSING_REGISTRATION_NUMBER = 'missingRegistrationNumber',
  INCORRECT_DISCOUNT_CODE = 'incorrectDiscountCode',
  DRIVER_SOS_DETAILS = 'driverSosDetails',
  PDF_VIEWER = 'pdfViewer',
  CLIENT_BLACK_LISTED = 'clientBlackListed',
  AZTEC_SCANNER_QR_DIALOG = 'aztecScannerQRDialog',
  IMAGE_PREVIEW_DIALOG = 'imagePreviewDialog',
}

export enum DialogAction {
  BACK_TO_FIRST_STEP = 'backToFirstStep',
  RESET_APPLICATION = 'resetApplication',
  ENABLE_SCROLLING = 'enableScrolling',
  SHOW_SECOND_STEP = 'showSecondStep',
  BACK_TO_OFFERS = 'backToOffers',
  PAY_AFTER_RECALCULATION = 'payAfterRecalculation',
  BACK_TO_PERSONAL_DATA = 'backToPersonalData'
}

export interface DialogActionConfig {
  actionKey: DialogAction;
  callback: () => void;
  isDefault?: boolean; // when true, action callback will be performed if close result is undefined
}
